import { convertUserToNewUser } from 'common/utils/new-user';
import SuggestedCreatorsWidget from 'components/v2/organisms/suggested-creators-widget';
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { MinimizedUserInfoType } from 'service/timeline';
import { getCreatorSpotlights } from 'service/user';
import useGlobalStore from 'store/global';

import PinPostsSection from './pin-posts-section';

const ProfilePageRightSidebar = () => {
  const isAuthInit = useGlobalStore((state) => state.isAuthInit);

  const { data: userSpotlightData } = useQuery(
    'getUserSpotlights',
    async () => {
      if (!isAuthInit) return Promise.reject();
      return await getCreatorSpotlights({
        page: 1,
        size: 20,
        is_ranking_page: false,
      });
    },
    {
      enabled: isAuthInit,
      refetchOnWindowFocus: false,
      staleTime: 15 * 60 * 1000,
      cacheTime: 15 * 60 * 1000,
    },
  );

  const creators: MinimizedUserInfoType[] = useMemo(() => {
    return (userSpotlightData?.data?.creator_posts || [])
      .slice(0, 5)
      .map((spotlight) => {
        return convertUserToNewUser(spotlight.user_info);
      });
  }, [userSpotlightData?.data?.creator_posts]);

  return (
    <div className="scrollbar-hide sticky top-16 z-50 ml-auto hidden h-[calc(100vh-64px)] w-[260px] overflow-y-auto pb-3 pt-[15px] grid-in-rightSidebar xl:block">
      {/* Pin Posts Section */}
      <PinPostsSection />
      {/* Suggested Creators Widget */}
      <SuggestedCreatorsWidget creators={creators} title="注目クリエイター" />
    </div>
  );
};

export default ProfilePageRightSidebar;
